// extracted by mini-css-extract-plugin
export default {"form":"form_form__6O+1w","sticky_action":"form_sticky_action__LOzAe","sticky_container":"form_sticky_container__Kq-I6","danger":"form_danger__1yuav"};